import { useEffect, useRef } from 'react';
import { btnGhost, btnPrimary } from '../ui/styles';
import { dayMedium } from '../../core/format/dates';
import type { AgendaAppointment, AgendaSeriesResult, SeriesSkipReason } from '../../core/types/agenda';
type Props = {
  result: AgendaSeriesResult;
  onOpen: (a: AgendaAppointment) => void;
  onClose: () => void;
};
const reasonLabel: Record<SeriesSkipReason, string> = {
  bezet: 'tijd bezet',
  gesloten: 'salon dicht',
  voorbij: 'al voorbij'
};

/**
 * Na een reeks met datums die niet lukten: wat er wel staat, en welke datums Sarah zelf nog moet
 * oplossen (een andere tijd kiezen via Nieuwe afspraak, of overslaan).
 */
export function SeriesOutcome({
  result,
  onOpen,
  onClose
}: Props) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => headingRef.current?.focus(), []);
  const first = result.created[0];
  return <div className="space-y-5" data-id="element-504" data-mp="8qakzls1hx8">
      <div data-id="element-505" data-mp="560a582vr9ys">
        <h2 ref={headingRef} tabIndex={-1} className="font-display text-[1.4rem] font-light text-ink focus:outline-none" data-id="element-506" data-mp="54fbb69j94v4">
          {result.created.length === 0 ? 'Niets ingepland' : `${result.created.length} van de ${result.created.length + result.skipped.length} ingepland`}
        </h2>
        <p className="mt-0.5 text-[13px] text-muted" data-id="element-507" data-mp="35yk8y2jq5pca">Deze datums lukten niet. Plan ze los in op een andere tijd, of laat ze vallen.</p>
      </div>

      <ul className="divide-y divide-line border-y border-line text-[14px]" data-id="element-508" data-mp="30x4ks1m932po">
        {result.skipped.map(s => <li key={s.date} className="flex items-baseline justify-between gap-3 py-2.5" data-id="element-509" data-mp="2981gwmy9zudk">
            <span className="text-ink" data-id="element-510" data-mp="29687x106wy2e">{dayMedium(s.date)}</span>
            <span className="text-[13px] text-clay" data-id="element-511" data-mp="2n07wo7xinzch">{reasonLabel[s.reason]}</span>
          </li>)}
      </ul>

      <div className="flex flex-wrap items-center gap-2" data-id="element-512" data-mp="2i7ethohp4z2i">
        {first && <button type="button" onClick={() => onOpen(first)} className={btnPrimary} data-id="element-513" data-mp="1uhu68teiffnf">
            Eerste afspraak openen
          </button>}
        <button type="button" onClick={onClose} className={btnGhost} data-id="element-514" data-mp="3pmbfcxitolq1">
          Sluiten
        </button>
      </div>
    </div>;
}